import { Card, Grid, ListSubheader, MenuItem, Select, TextField, Typography, InputAdornment, Button, RadioGroup, FormControlLabel, Radio, Divider, Box, Tabs, Tab, Paper } from '@mui/material';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import LeaveCard from './LeaveCard';
import ApprovedLeaves from './ApprovedLeaves';
import RejectedLeaves from './RejectedLeaves';
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { getLeaveList, getAssignedRequests } from 'src/services/leaveService';
import { RootStateType } from 'src/store/RootReducer';
import { withStyles } from '@mui/styles';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { leaveRequestStatus, userRoles } from 'src/models/leave.enum';
import { LeaveManagementActions } from 'src/store/LeaveManagementReducer';

interface Props{
  onView:(data:any)=>void;
  onDataChange?:(data:boolean)=>void;
}

export interface LeaveInformation {
  name: string;
  designation: string;
  email: string;
  contact: string;
  segment: string;
  customer: string;
  HrApproval: string
}

const LeaveDashboard = (props:Props) => {

  //temporally added due to technical issue in BE pagination(currentPageNo, currentPageSize)
  const currentPageNo: number = 1;
  const currentPageSize: number = 1000;

  const tabIds: String[] = ['one', 'two', 'three', 'four', 'five'];

  const dispatch = useDispatch();

  const TextFieldStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const dateStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const errorStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '11px',
    color: 'red'
  }

  const CustomTableColumn = withStyles({
    root: {
      height: '3rem'
    }
  })(Card);

  const [leaveList, setLeaveList] = useState<any>([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [lieuLeaveCount, setLieuLeaveCount] = useState(0);
  const [rmApprovedCount, setRmApprovedCount] = useState(0);
  const [isRecordsAvailable, setIsRecordsAvailable] = useState(false);
  const [dataChange, setDataChange] = useState(false);

  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const isReportingManager = useSelector((state: RootStateType) => state.leaveManagementReducer.isReportingManager);
  const isClickedViewLeave = useSelector((state: RootStateType) => state.leaveManagementReducer.isClickedViewLeave);

  const validateUserRole = (userRole) => {
    const user_role = userRole.split(',');
    if (user_role.includes(userRoles.HR_Manager) || 
      user_role.includes(userRoles.SUPER_USER)) {
      return 'HR_MANAGER';
    } else if (user_role.includes(userRoles.ASSISTANT_HR_MANAGER)) {
      return 'ASSISTANT_HR_MANAGER';
    } else if (user_role.includes(userRoles.HR_EXECUTIVE)) {
      return 'HR_EXECUTIVE';
    } else {
      return 'REPORTING_MANAGER';
    }
  }

  const newLeaveRequestArray = leaveList.map((obj) => {
    return {
      ...obj,
      fromDateByOrder: obj.fromDate,
    }
  });

  const sortedLeaveList = newLeaveRequestArray
  /* const sortedLeaveList = newLeaveRequestArray.map(obj => {
    return { ...obj, fromDateByOrder: new Date(obj.fromDateByOrder)}
  }).sort((a, b) => a.fromDateByOrder - b.fromDateByOrder); */


  //reload data after action
  const handleChildData = (data) => {
    if(data){
      getAllLeaveRequests(value);
      if(value === "one" || value === "two"){
        setDataChange(prevDataChange => !prevDataChange);
      }
    }
  }

  useEffect(() => {
    props.onDataChange && props.onDataChange(dataChange);
  }, [dataChange]);


  const handleApprovedChildData = (data) => {
    if (data.status === leaveRequestStatus.APPROVED) {
      getAllLeaveRequests(value);
    } else if (data.status === leaveRequestStatus.REJECTED) {
      getAllLeaveRequests(value);
    }
  }

  const fetchMoreData = () => {
    setTimeout(() => {
    }, 1500);
  };

  //set tabs value
  const [value, setValue] = useState<any>(tabIds[0]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setLeaveList([]);
    setValue(newValue);
  };

  useEffect(() => {
    if (isClickedViewLeave === 'pending') {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(""));
      setValue('one');
      getAllLeaveRequests('one');
    }
    else if (isClickedViewLeave === 'lieuLeave') {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(""));
      setValue('two');
      getAllLeaveRequests('two');
    }
    else if(isClickedViewLeave === 'rmApproved') {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(""));
      setValue('three');
      getAllLeaveRequests('three');
    }
    else if(isClickedViewLeave === 'approved') {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(""));
      setValue('four');
      getAllLeaveRequests('four');
    }
    else if(isClickedViewLeave === 'rejected') {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(""));
      setValue('five');
      getAllLeaveRequests('five');
    } 
    else{
      getAllLeaveRequests(value);
    }
  },[value]);

  const getAllLeaveRequests = (tabNumber:string) => {
    dispatch(AppActions.showLoader());
    
    let leaveStatus: string = '';
    let isEligible: boolean = false;
    let leaveType: string = '';
    let hrApproved: boolean = false;
    let filter: string = '';
    let isLeaveCountRequired: boolean = false;

    if(tabNumber === tabIds[0]) {
      leaveStatus = leaveRequestStatus.PENDING;
      isEligible = false;
      isLeaveCountRequired = true;
    }else if(tabNumber === tabIds[1]) {
      leaveStatus = leaveRequestStatus.PENDING;
      isEligible = true;
      leaveType = 'Lieu Leave';
      isLeaveCountRequired = true;
    }else if(tabNumber === tabIds[2]) {
      leaveStatus = leaveRequestStatus.RM_APPROVED;
      isEligible = false;
      hrApproved = true;
      isLeaveCountRequired = true;
    }else if(tabNumber === tabIds[3]) {
      leaveStatus = leaveRequestStatus.APPROVED;
      isEligible = null;
      isLeaveCountRequired = true;
    }else {
      leaveStatus = leaveRequestStatus.REJECTED;
      isEligible = null;
      isLeaveCountRequired = true;
    }
    
    getAssignedRequests(leaveStatus, currentPageNo, currentPageSize, validateUserRole(appUser.Roles), isEligible, leaveType, hrApproved, filter, isLeaveCountRequired)
    .then((res) => {
      if (res.data.statusCode === 200) {

        if(!(tabNumber === tabIds[3] || tabNumber === tabIds[4])) {
          setPendingCount(res?.data?.data?.leaveRequestCount?.pendingCount ? res.data.data.leaveRequestCount.pendingCount : 0);
          setLieuLeaveCount(res?.data?.data?.leaveRequestCount?.lieuLeaveEligibilityCount ? res.data.data.leaveRequestCount.lieuLeaveEligibilityCount : 0)
          setRmApprovedCount(res?.data?.data?.leaveRequestCount?.rmApprovedCount ? res.data.data.leaveRequestCount.rmApprovedCount : 0);
        }
          
        if (res.data?.data?.leaveAssignedList.length !== 0) {
          setLeaveList(res.data?.data?.leaveAssignedList);
          setIsRecordsAvailable(true);
        } else {
          setIsRecordsAvailable(false);
        }
        dispatch(AppActions.hideLoader());
      }

    }).catch((e) => {
      if(e.response?.status === 400){
        setPendingCount(0);
        setRmApprovedCount(0);
        setLieuLeaveCount(0);
        setIsRecordsAvailable(false);
      }
      dispatch(AppActions.hideLoader());
    });
  }

  return (
    <Card className='leave-dashboard' style={{ padding: '1rem', maxHeight: '43rem' }} >
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="wrapped label tabs example"
        >
          <Tab
            value="one"
            label={"Pending ".concat("(", pendingCount.toString(), ")")}
            wrapped
          />
          <Tab value="two" label={"Lieu Leave Eligibility ".concat("(", lieuLeaveCount.toString(), ")")} />
          {(appUser.Roles.split(',').includes(userRoles.HR_Manager) ||
            appUser.Roles.split(',').includes(userRoles.SUPER_USER) ||
            appUser.Roles.split(',').includes(userRoles.ASSISTANT_HR_MANAGER)) && (
            <Tab value="three" label={'PM/RM Approved'.concat('(', rmApprovedCount.toString(), ')')} wrapped/>
          )}
          <Tab value="four" label="Approved" />
          <Tab value="five" label="Rejected" />
        </Tabs>
      </Box>
      <InfiniteScroll
        style={{ maxHeight: '34rem', overflow: 'auto' }}
        dataLength={sortedLeaveList.length}
        next={fetchMoreData}
        hasMore={true}
        loader={''}
      >
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '0.8rem',
            width: '100%',
            marginLeft: 0,
            minHeight: '20rem'
          }}
        >
          {value === tabIds[0] ? (
            isRecordsAvailable ? (
              <>
                {sortedLeaveList.map((item) => (
                  <LeaveCard
                    onView={props.onView}
                    leaveDetails={item}
                    onDataChange={handleChildData}
                    tabValue={value}
                  />
                ))}
              </>
            ) : (
              <CustomTableColumn
                style={{
                  width: '100%',
                  height: '25rem'
                }}
              >
                <Grid
                  spacing={2}
                  style={{
                    marginTop: '8rem',
                    width: '100%',
                    marginLeft: 0,
                    minHeight: '25rem'
                  }}
                >
                  <InboxOutlinedIcon
                    style={{
                      textAlign: 'center',
                      marginLeft: '47%',
                      fontSize: 50,
                      opacity: 0.4
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: '15px',
                      fontWeight: 'normal',
                      textAlign: 'center'
                    }}
                  >
                    No Records Found
                  </Typography>
                </Grid>
              </CustomTableColumn>
            )
          ) : value === tabIds[1] ? (
            isRecordsAvailable ? (
              <>
                {sortedLeaveList.map((item) => (
                  <LeaveCard
                    onView={props.onView}
                    leaveDetails={item}
                    tabValue={value}
                    onDataChange={handleChildData}
                  />
                ))}
              </>
            ) : (
              <CustomTableColumn
                style={{
                  width: '100%',
                  height: '25rem'
                }}
              >
                <Grid
                  spacing={2}
                  style={{
                    marginTop: '8rem',
                    width: '100%',
                    marginLeft: 0,
                    minHeight: '25rem'
                  }}
                >
                  <InboxOutlinedIcon
                    style={{
                      textAlign: 'center',
                      marginLeft: '47%',
                      fontSize: 50,
                      opacity: 0.4
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: '15px',
                      fontWeight: 'normal',
                      textAlign: 'center'
                    }}
                  >
                    No Records Found
                  </Typography>
                </Grid>
              </CustomTableColumn>
            )
          ) :value === tabIds[2] ? (
            isRecordsAvailable ? (
              <>
                {sortedLeaveList.map((item) => (
                  <LeaveCard
                    onView={props.onView}
                    leaveDetails={item}
                    tabValue={value}
                    onDataChange={handleChildData}
                  />
                ))}
              </>
            ) : (
              <CustomTableColumn
                style={{
                  width: '100%',
                  height: '25rem'
                }}
              >
                <Grid
                  spacing={2}
                  style={{
                    marginTop: '8rem',
                    width: '100%',
                    marginLeft: 0,
                    minHeight: '25rem'
                  }}
                >
                  <InboxOutlinedIcon
                    style={{
                      textAlign: 'center',
                      marginLeft: '47%',
                      fontSize: 50,
                      opacity: 0.4
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: '15px',
                      fontWeight: 'normal',
                      textAlign: 'center'
                    }}
                  >
                    No Records Found
                  </Typography>
                </Grid>
              </CustomTableColumn>
            )
          ) : value === tabIds[3] ? (
            <ApprovedLeaves
              onView={props.onView}
              leaveDetails={sortedLeaveList}
              userDetails={{
                role: validateUserRole(appUser.Roles),
                rmId: appUser?.EmployeeId
              }}
              onDataChange={handleApprovedChildData}
            />
          ) : (
            <RejectedLeaves
              onView={props.onView}
              leaveDetails={sortedLeaveList}
              userDetails={{
                role: validateUserRole(appUser.Roles),
                rmId: appUser?.EmployeeId
              }}
              onDataChange={handleApprovedChildData}
            />
          )}
        </Grid>
      </InfiniteScroll>
    </Card>
  );
};

export default LeaveDashboard;
